import axios from "axios";
import { config } from "../../Utils/helpers";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// List Finance Partners
export const listFinancePartners = (page = 1, limit = 10, otherFilters = {}) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_FINANCE_PARTNER_LIST_REQUEST" });
      const payload = { page, limit, ...otherFilters };
      const { data } = await axios.post(
        `${BASE_URL}/finance-partner/list`,
        payload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_FINANCE_PARTNER_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FINANCE_PARTNER_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FINANCE_PARTNER_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch finance partners");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// View Finance Partner
export const viewFinancePartner = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_FINANCE_PARTNER_REQUEST" });
      const { data } = await axios.get(
        `${BASE_URL}/finance-partner/view/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_FINANCE_PARTNER_SUCCESS", payload: data.data });
        return data;
      } else {
        dispatch({ type: "GET_FINANCE_PARTNER_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FINANCE_PARTNER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch finance partner");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Add Finance Partner
export const addFinancePartner = (financeData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_FINANCE_PARTNER_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/finance-partner/add`,
        financeData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_FINANCE_PARTNER_SUCCESS", payload: data });
        toast.success("Finance partner added successfully");
        return data;
      } else {
        dispatch({ type: "ADD_FINANCE_PARTNER_FAILED", payload: data });
        toast.error(data.message || "Failed to add finance partner");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_FINANCE_PARTNER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to add finance partner");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Update Finance Partner
export const updateFinancePartner = (updateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_FINANCE_PARTNER_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/finance-partner/update`,
        updateData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_FINANCE_PARTNER_SUCCESS", payload: data });
        toast.success("Finance partner updated successfully");
        return data;
      } else {
        dispatch({ type: "UPDATE_FINANCE_PARTNER_FAILED", payload: data });
        toast.error(data.message || "Failed to update finance partner");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_FINANCE_PARTNER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to update finance partner");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Change Status
export const updateFinancePartnerStatus = (statusData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_FINANCE_PARTNER_STATUS_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/finance-partner/update-status`,
        statusData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_FINANCE_PARTNER_STATUS_SUCCESS", payload: data });
        toast.success("Status updated successfully");
        return data;
      } else {
        dispatch({ type: "UPDATE_FINANCE_PARTNER_STATUS_FAILED", payload: data });
        toast.error(data.message || "Failed to update status");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_FINANCE_PARTNER_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to update status");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Remove Finance Partner
export const removeFinancePartner = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_FINANCE_PARTNER_REQUEST" });
      const { data } = await axios.delete(
        `${BASE_URL}/finance-partner/remove/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_FINANCE_PARTNER_SUCCESS", payload: data });
        toast.success("Finance partner removed successfully");
        return data;
      } else {
        dispatch({ type: "REMOVE_FINANCE_PARTNER_FAILED", payload: data });
        toast.error(data.message || "Failed to remove finance partner");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_FINANCE_PARTNER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to remove finance partner");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// List Users for Finance Partner
export const listFinancePartnerUsers = (finance_partner_id, page = 1, limit = 10) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_FINANCE_PARTNER_USER_LIST_REQUEST" });
      const payload = { finance_partner_id, page, limit };
      const { data } = await axios.post(
        `${BASE_URL}/finance-partner/user-list`,
        payload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_FINANCE_PARTNER_USER_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FINANCE_PARTNER_USER_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FINANCE_PARTNER_USER_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch users");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
